import {useNavigate} from 'react-router-dom'

import check from './asset/check.svg'
import checked from './asset/checked.svg'
import Style from './style'

import MainHeader from 'widget/MainHeader'

import useRoleCookie from 'shared/model/useRoleCookie'

import useDeleteSubManagerApprove from 'entity/sub-manager/useDeleteSubManagerApprove'
import useGetSubManagerList from 'entity/sub-manager/useGetSubManagerList'
import usePostSubManagerApprove from 'entity/sub-manager/usePostSubManagerApprove'
import {
	convertRoleAsName,
	ROLE_COMPETITION_MANAGER,
} from 'shared/constant/lookup/role'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TStyle from 'shared/style/tableStyle'
import TableLoading from 'shared/ui/TableLoading'

const SubManagerList = () => {
	const navigate = useNavigate()

	const [subManagerList, isLoading] = useGetSubManagerList()
	const [approveManager] = usePostSubManagerApprove()
	const [unapproveManager] = useDeleteSubManagerApprove()

	const [userRole] = useRoleCookie()

	const sizeList = ['short', 'long', 'long', 'expand', 'long', 'long', 'long']
	const tableHeadList = [
		'IDX',
		'역할',
		'ID',
		'이름',
		'연락처',
		'승인',
		'Creation Date',
	]

	const btnList =
		userRole === ROLE_COMPETITION_MANAGER
			? [
					{
						label: '새 관리자 계정 생성',
						clickEvent: () => navigate('/manager/sub-manager/create'),
					},
				]
			: []

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>매니저 계정 목록</MainHeader>
			{/* <Search placeholder='프랜차이즈 이름에 포함되는 글자로 검색' /> */}

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{subManagerList?.data?.sub_manager_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => {
									navigate(`/manager/sub-manager/${elem?.idx}/detail`)
								}}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>
									{convertRoleAsName[elem?.manager_role_flag] || '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>{elem?.id}</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>{elem?.contact}</TStyle.Data>
								<TStyle.Data
									$size={sizeList[5]}
									onClick={(e) =>
										elem?.is_approve
											? unapproveManager(e, elem?.idx)
											: approveManager(e, elem?.idx)
									}
								>
									<Style.Radio>
										<img src={elem?.is_approve ? checked : check} alt='check' />
									</Style.Radio>
								</TStyle.Data>
								<TStyle.Data $size={sizeList[6]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			{/* <Pagenation maxPage={franchiseManagerList?.data?.max_page} /> */}
		</Style.Wrapper>
	)
}

export default SubManagerList
